export enum ProceduresEvents {
    userCreatedProcedureFromSettings = 'user_created_procedure_from_settings',
}
